import React, { useEffect, useState } from "react";
import { getSlackUrls, saveSlackUrls } from "../../../features/gyms/helper/api";
import { isAuthenticated } from "../../../auth";
import { startLoader, stopLoader } from "../../../lib/utils";
import Toast from "../../../lib/toast";

const ManageSlack = (props) => {


  const [slackLinkList, setSlackLinkList] = useState([]);
  const [deleteIDs,setDeleteIDs] = useState([])
  const [slackType, setSlackType] = useState(["NEW_SALE"]);
  const [currentElementId, setCurrentElementId] = useState("");
  const [slackTypeIndex, setSlackTypeIndex] = useState(-1);
  const [Branch,setBranch] = useState('');
  const [isButtonLock,setButtonLock] = useState([]);
  const [visibleCount, setVisibleCount] = useState(1);

  const {user,token} = isAuthenticated();


  const displayTypeName = (type) =>{
    return type == "NEW_SALE"?"New Sale":""
  }


  const handleAddSlackLink = () => {
    setSlackLinkList([{ link: "", type: "" }, ...slackLinkList]);
    setVisibleCount(prev => prev + 1);
  }

  const toggleInputFields = (id, indexValue) => event => {
    setCurrentElementId(id);

    if(id == "slack-type"){
      if(slackTypeIndex == -1){
        setSlackTypeIndex(indexValue)
      }else{
        setSlackTypeIndex(-1)
      }
    }

    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
            element.focus();
            clearInterval(interval)
        }
      }, 0);
    }
  }

  const handleSlackLink = (e,index) => {
    const updatedLinkList = [...slackLinkList];
    updatedLinkList[index] = { ...updatedLinkList[index], link: e.target.value };
    setSlackLinkList(updatedLinkList);
  }

  const handleDeleteSlackLink = (index) => {
    const slackUrl  = slackLinkList[index];

    if(slackUrl && slackUrl._id){
      setDeleteIDs([...deleteIDs,slackUrl._id])
    }
    const updatedLinkList = slackLinkList.filter((_, i) => i !== index);
    setSlackLinkList(updatedLinkList);
    setVisibleCount(prev => Math.max(prev - 1, 1));
  }


  const SaveSlackUrls = async event =>{
    event.preventDefault();
    try{
      await startLoader()
      setButtonLock(true)
      const payload = {
        deletedIds:deleteIDs,
        slackPayloads:[]
      }

      payload.slackPayloads=slackLinkList.map(d=>({_id:d._id,webHookUrl:d.link,type:d.type}))

      const response = await saveSlackUrls(user._id,token,Branch._id,payload);
      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Slack url saved successfully"
        })
      }
      setButtonLock(false)
      if(props.handleManageSlackModal) props.handleManageSlackModal();
      setSlackLinkList([]);
      await stopLoader()
    }catch(error){
      await stopLoader();
      setButtonLock(false);
    }
  }

  const GetSlackUrls=async ()=>{
    try{
      const params={
        branchIDs:[Branch._id],
        noLimit:"noLimit"
      }
      const response = await getSlackUrls(user._id,token,params);
      if(response.error){
        setSlackLinkList([{
            link: "",
            type: "NEW_SALE"
        }])
        setVisibleCount(1);
      }else{
        if(response.length){
          let slackurlList = await Promise.all(response.map(data=>{
            return {
              type:data.type,
              link:data.webHookUrl,
              _id:data._id
            };
          }))

          setSlackLinkList(slackurlList);
          setVisibleCount(slackurlList.length);
        }
        else {
          setSlackLinkList([{
            link: "",
            type: "NEW_SALE"
          }])
          setVisibleCount(1);
        }
      }
    }catch(error){
      setSlackLinkList([{
         link: "",
         type: "NEW_SALE"
      }])
      setVisibleCount(1);
    }
  }


  const handleSelectSlack = (type,index)=>{
    setSlackLinkList(oldstate=>{
      oldstate[index].type = type;
      return [...oldstate];
    })
  }

  useEffect(()=>{
    setButtonLock(slackLinkList.length?false:true);
  },[slackLinkList])

  useEffect(()=>{
    if(props.branch){
       setBranch(props.branch);
    }
  },[props])

  useEffect(()=>{
    if(Branch){
      GetSlackUrls();
    }
  },[Branch])

  //  MOBILE LAYOUT
  if (props.hideHeader) {
    return (
      <div className="w-full" style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column" }}>

        
        <div className="slack-mobile-scroll" style={{ flex: 1, overflowY: "auto", padding: "14px", paddingBottom: "84px" }}>

          <div
            onClick={()=>handleAddSlackLink()}
            className='member-button-global btn-center flex-item d-flex'
            style={{padding: "0px 16px", height: "40px", width:"auto", marginBottom:"16px"}}
          >
            <p className='flex-item'>Add Link</p>
          </div>

          {
            slackLinkList.map((data, index) => {
              if (index >= visibleCount) return null;
              return (
                <div key={index} className="w-full" style={{background:"#ffffff", borderRadius:"20px", padding:"20px 16px 18px", position:"relative", boxShadow:"0px 2px 10px rgba(0,0,0,0.07)", marginBottom:"16px"}}>

                  {/* Delete icon - top right corner of the card, like reference design */}
                  <div
                    onClick={()=>handleDeleteSlackLink(index)}
                    className="d-flex flex-item desktop-modal-close-button"
                    style={{position:"absolute", top:"12px", right:"12px", width:"30px", height:"30px"}}
                  >
                    <svg className="flex-item margin-auto" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.616 20C7.168 20 6.78667 19.8427 6.472 19.528C6.15733 19.2133 6 18.8323 6 18.385V6H5V5H9V4.23H15V5H19V6H18V18.385C18 18.845 17.846 19.2293 17.538 19.538C17.23 19.8467 16.8453 20.0007 16.384 20H7.616ZM17 6H7V18.385C7 18.5643 7.05767 18.7117 7.173 18.827C7.28833 18.9423 7.436 19 7.616 19H16.385C16.5383 19 16.6793 18.936 16.808 18.808C16.9367 18.68 17.0007 18.5387 17 18.384V6ZM9.808 17H10.808V8H9.808V17ZM13.192 17H14.192V8H13.192V17Z" fill="black"/>
                    </svg>
                  </div>

                  {/* Slack Link field */}
                  <div
                    onClick={toggleInputFields('slack-link-'+index)}
                    className={`${(currentElementId == 'slack-link-'+index || data.link) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`}
                    style={{ border: (currentElementId == 'slack-link-'+index || data.link) ? "1px solid var(--darkBlue)" : "", width: "100%", marginTop:"32px", marginBottom:"16px" }}
                  >
                    <div className="flex-item d-flex">
                      <svg className="flex-item m-r-4" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.3803 12.2222L17.1984 9.40408C18.2362 8.36624 18.2709 6.71885 17.2757 5.72434C16.2812 4.72911 14.6338 4.76378 13.596 5.80162L10.7779 8.61975M12.2223 14.3614L9.41147 17.1637C8.37726 18.1965 6.7826 18.3301 5.74117 17.241C4.69974 16.1526 4.78351 14.6128 5.81845 13.5807L8.62931 10.7778M9.33347 13.6667L13.6668 9.33331" stroke={(currentElementId == 'slack-link-'+index || data.link) ? "var(--darkBlue)" : "#6d6d6d"} stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'slack-link-'+index || data.link) ? "10px" : "14px", color: (currentElementId == 'slack-link-'+index || data.link) ? "var(--darkBlue)" : "", transition: "180ms" }}>Slack Link</p>
                    </div>
                    <input value={data.link} onChange={(e)=> handleSlackLink(e, index)} className={`${(currentElementId == 'slack-link-'+index || data.link) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                  </div>

                  {/* User Role field */}
                  <div
                    onClick={toggleInputFields('slack-type', index)}
                    className={`${(currentElementId == "slack-type" || data.type) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`}
                    style={{ border: (currentElementId == "slack-type" || data.type) ? "1px solid var(--darkBlue)" : "", width: "100%" }}
                  >
                    <div className="flex-item d-flex">
                      <svg className="flex-item m-r-8" width="18" height="18" style={{ transition: "180ms" }} viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.73333 1H3.1C3.00717 1 2.91815 1.03687 2.85251 1.10251C2.78687 1.16815 2.75 1.25717 2.75 1.35V6.48333C2.75 6.5293 2.75905 6.57481 2.77664 6.61727C2.79423 6.65974 2.82001 6.69832 2.85251 6.73082C2.88501 6.76332 2.9236 6.7891 2.96606 6.80669C3.00852 6.82428 3.05404 6.83333 3.1 6.83333H4.73333C4.7793 6.83333 4.82481 6.82428 4.86727 6.80669C4.90974 6.7891 4.94832 6.76332 4.98082 6.73082C5.01332 6.69832 5.0391 6.65974 5.05669 6.61727C5.07428 6.57481 5.08333 6.5293 5.08333 6.48333V1.35C5.08333 1.25717 5.04646 1.16815 4.98082 1.10251C4.91518 1.03687 4.82616 1 4.73333 1V1ZM11.7333 1H10.1C10.0072 1 9.91815 1.03687 9.85251 1.10251C9.78687 1.16815 9.75 1.25717 9.75 1.35V6.48333C9.75 6.5293 9.75905 6.57481 9.77664 6.61727C9.79423 6.65974 9.82001 6.69832 9.85251 6.73082C9.88501 6.76332 9.9236 6.7891 9.96606 6.80669C10.0085 6.82428 10.054 6.83333 10.1 6.83333H11.7333C11.7793 6.83333 11.8248 6.82428 11.8673 6.80669C11.9097 6.7891 11.9483 6.76332 11.9808 6.73082C12.0133 6.69832 12.0391 6.65974 12.0567 6.61727C12.0743 6.57481 12.0833 6.5293 12.0833 6.48333V1.35C12.0833 1.25717 12.0465 1.16815 11.9808 1.10251C11.9152 1.03687 11.8262 1 11.7333 1V1Z" stroke={(currentElementId == "slack-type" || data.type) ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5.08333 3.91675H9.75M1 5.31675V2.51675C1 2.42392 1.03687 2.3349 1.10251 2.26926C1.16815 2.20362 1.25717 2.16675 1.35 2.16675H2.4C2.49283 2.16675 2.58185 2.20362 2.64749 2.26926C2.71313 2.3349 2.75 2.42392 2.75 2.51675V5.31675C2.75 5.40957 2.71313 5.4986 2.64749 5.56424C2.58185 5.62987 2.49283 5.66675 2.4 5.66675H1.35C1.25717 5.66675 1.16815 5.62987 1.10251 5.56424C1.03687 5.4986 1 5.40957 1 5.31675V5.31675ZM13.8333 5.31675V2.51675C13.8333 2.42392 13.7965 2.3349 13.7308 2.26926C13.6652 2.20362 13.5762 2.16675 13.4833 2.16675H12.4333C12.3405 2.16675 12.2515 2.20362 12.1858 2.26926C12.1202 2.3349 12.0833 2.42392 12.0833 2.51675V5.31675C12.0833 5.40957 12.1202 5.4986 12.1858 5.56424C12.2515 5.62987 12.3405 5.66675 12.4333 5.66675H13.4833C13.5762 5.66675 13.6652 5.62987 13.7308 5.56424C13.7965 5.4986 13.8333 5.40957 13.8333 5.31675V5.31675Z" stroke={(currentElementId == "slack-type" || data.type) ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "slack-type" || data.type) ? "10px" : "14px", color: (currentElementId == "slack-type" || data.type) ? "var(--darkBlue)" : "", transition: "180ms" }}>User Role*</p>
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" style={{ transform: slackTypeIndex == index ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                    <input id="slack-type" className={`${(currentElementId == "slack-type" || data.type) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select User Role" value={displayTypeName(data.type)} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
                    {
                      slackTypeIndex == index && (
                        <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                          {
                            slackType.map((d) => {
                              return (
                                <div onClick={()=>handleSelectSlack(d,index)} className="global-input-field-arrow-dropdown-item">
                                  <p className="flex-item">{displayTypeName(d)}</p>
                                </div>
                              )
                            })
                          }
                        </div>
                      )
                    }
                  </div>
                </div>
              )
            })
          }
        </div>

        {/* Save button - fixed at the very bottom of the drawer, always visible */}
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "12px 14px", background: "#ffffff", boxShadow: "0px -2px 10px rgba(0,0,0,0.06)" }}>
          <div
            onClick={SaveSlackUrls}
            className={`member-button-global ${isButtonLock && "member-button-global-inactive"} btn-center flex-item d-flex w-full`}
            style={{padding: "0px 16px", height: "40px", borderRadius: "20px"}}
          >
            <p className='flex-item'>Save</p>
          </div>
        </div>
      </div>
    )
  }

  // DESKTOP LAYOUT
  return (
    <div className="global-modal-container d-flex">
      <div className="global-modal-type-2 slack-sync-modal flex-item">
        <div className="d-flex w-full space-between" style={{background: "#DEF3FF", padding:"12px", borderRadius: "16px 16px 0 0"}}>
          <div className='d-flex'>
            <svg className='flex-item m-r-8' width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.53 2.75C9.03935 2.75 8.56879 2.94491 8.22185 3.29185C7.87491 3.63879 7.68 4.10935 7.68 4.6C7.68 5.09065 7.87491 5.56121 8.22185 5.90815C8.56879 6.25509 9.03935 6.45 9.53 6.45H11.38V4.6C11.3807 4.35771 11.3336 4.11766 11.2415 3.89357C11.1494 3.66947 11.014 3.46571 10.8431 3.29392C10.6723 3.12213 10.4693 2.98568 10.2457 2.89235C10.0221 2.79903 9.78229 2.75066 9.54 2.75M9.54 7.68H4.6C4.35705 7.68 4.11649 7.72785 3.89204 7.82082C3.66758 7.91379 3.46364 8.05006 3.29185 8.22185C3.12006 8.39364 2.98379 8.59758 2.89082 8.82204C2.79785 9.04649 2.75 9.28705 2.75 9.53C2.75 9.77295 2.79785 10.0135 2.89082 10.238C2.98379 10.4624 3.12006 10.6664 3.29185 10.8381C3.46364 11.0099 3.66758 11.1462 3.89204 11.2392C4.11649 11.3321 4.35705 11.38 4.6 11.38H9.53C10.0207 11.38 10.4912 11.1851 10.8381 10.8381C11.1851 10.4912 11.38 10.0207 11.38 9.53C11.38 9.03935 11.1851 8.56879 10.8381 8.22185C10.4912 7.87491 10.0207 7.68 9.53 7.68M7.68 14.47V19.4C7.68 19.8907 7.87491 20.3612 8.22185 20.7081C8.56879 21.0551 9.03935 21.25 9.53 21.25C10.0207 21.25 10.4912 21.0551 10.8381 20.7081C11.1851 20.3612 11.38 19.8907 11.38 19.4V14.47C11.3813 14.2275 11.3347 13.9872 11.2428 13.7628C11.1509 13.5384 11.0156 13.3344 10.8446 13.1625C10.6736 12.9905 10.4703 12.8541 10.2465 12.761C10.0226 12.6679 9.78248 12.62 9.54 12.62C9.04935 12.62 8.57879 12.8149 8.23185 13.1619C7.88491 13.5088 7.69 13.9793 7.69 14.47M21.25 9.53C21.25 9.03935 21.0551 8.56879 20.7081 8.22185C20.3612 7.87491 19.8907 7.68 19.4 7.68C18.9093 7.68 18.4388 7.87491 18.0919 8.22185C17.7449 8.56879 17.55 9.03935 17.55 9.53V11.38H19.4C19.8907 11.38 20.3612 11.1851 20.7081 10.8381C21.0551 10.4912 21.25 10.0207 21.25 9.53ZM16.32 9.53V4.6C16.32 4.35705 16.2721 4.11649 16.1792 3.89204C16.0862 3.66758 15.9499 3.46364 15.7781 3.29185C15.6064 3.12006 15.4024 2.98379 15.178 2.89082C14.9535 2.79785 14.7129 2.75 14.47 2.75C14.2271 2.75 13.9865 2.79785 13.762 2.89082C13.5376 2.98379 13.3336 3.12006 13.1619 3.29185C12.9901 3.46364 12.8538 3.66758 12.7608 3.89204C12.6679 4.11649 12.62 4.35705 12.62 4.6V9.53C12.62 10.0207 12.8149 10.4912 13.1619 10.8381C13.5088 11.1851 13.9793 11.38 14.47 11.38C14.9607 11.38 15.4312 11.1851 15.7781 10.8381C16.1251 10.4912 16.32 10.0207 16.32 9.53ZM14.47 21.25C14.9607 21.25 15.4312 21.0551 15.7781 20.7081C16.1251 20.3612 16.32 19.8907 16.32 19.4C16.32 18.9093 16.1251 18.4388 15.7781 18.0919C15.4312 17.7449 14.9607 17.55 14.47 17.55H12.62V19.4C12.62 19.8907 12.8149 20.3612 13.1619 20.7081C13.5088 21.0551 13.9793 21.25 14.47 21.25ZM14.47 16.32H19.4C19.6429 16.32 19.8835 16.2721 20.108 16.1792C20.3324 16.0862 20.5364 15.9499 20.7081 15.7781C20.8799 15.6064 21.0162 15.4024 21.1092 15.178C21.2021 14.9535 21.25 14.7129 21.25 14.47C21.25 14.2271 21.2021 13.9865 21.1092 13.762C21.0162 13.5376 20.8799 13.3336 20.7081 13.1619C20.5364 12.9901 20.3324 12.8538 20.108 12.7608C19.8835 12.6679 19.6429 12.62 19.4 12.62H14.47C13.9793 12.62 13.5088 12.8149 13.1619 13.1619C12.8149 13.5088 12.62 13.9793 12.62 14.47C12.62 14.9607 12.8149 15.4312 13.1619 15.7781C13.5088 16.1251 13.9793 16.32 14.47 16.32ZM2.75 14.47C2.75 14.9607 2.94491 15.4312 3.29185 15.7781C3.63879 16.1251 4.10935 16.32 4.6 16.32C5.09065 16.32 5.56121 16.1251 5.90815 15.7781C6.25509 15.4312 6.45 14.9607 6.45 14.47V12.62H4.6C4.10935 12.62 3.63879 12.8149 3.29185 13.1619C2.94491 13.5088 2.75 13.9793 2.75 14.47Z" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p className="flex-item modal-header-text">Slack</p>
          </div>
          <div className="d-flex">
            <div onClick={()=>handleAddSlackLink()} className='member-button-global btn-center flex-item d-flex m-r-25' style={{padding: "0px 16px", height: "30px", width:"auto"}}>
              <p className='flex-item'>Add Link</p>
            </div>
            <div onClick={()=>props.handleManageSlackModal()} className="d-flex flex-item desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
              <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
              </svg>
            </div>
          </div>
        </div>
        <div className="slack-link-scroll-container m-t-12 m-b-12">
          {
            slackLinkList.map((data, index) => {
              if (index >= visibleCount) return null;
              return(
                <div className='w-full space-between d-flex m-b-12' key={index}>
                  <div onClick={toggleInputFields('slack-link-'+index)} className={`${(currentElementId == 'slack-link-'+index || data.link) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'slack-link-'+index || data.link) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                    <div className="flex-item d-flex">
                      <svg className="flex-item m-r-4" width={(currentElementId == 'slack-link-'+index || data.link) ? "18" : "18"} height={(currentElementId == 'slack-link-'+index || data.link) ? "18" : "18"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.3803 12.2222L17.1984 9.40408C18.2362 8.36624 18.2709 6.71885 17.2757 5.72434C16.2812 4.72911 14.6338 4.76378 13.596 5.80162L10.7779 8.61975M12.2223 14.3614L9.41147 17.1637C8.37726 18.1965 6.7826 18.3301 5.74117 17.241C4.69974 16.1526 4.78351 14.6128 5.81845 13.5807L8.62931 10.7778M9.33347 13.6667L13.6668 9.33331" stroke={(currentElementId == 'slack-link-'+index || data.link) ? "var(--darkBlue)" : "#6d6d6d"} stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'slack-link-'+index || data.link) ? "10px" : "14px", color: (currentElementId == 'slack-link-'+index || data.link) ? "var(--darkBlue)" : "", transition: "180ms" }}>Slack Link</p>
                    </div>
                    <input value={data.link} onChange={(e)=> handleSlackLink(e, index)} className={`${(currentElementId == 'slack-link-'+index || data.link) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                  </div>
                  <div onClick={toggleInputFields('slack-type', index)} className={`${(currentElementId == "slack-type" || data.type) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "slack-type" || data.type) ? "1px solid var(--darkBlue)" : "", width: "40%" }}>
                    <div className="flex-item d-flex">
                      <svg className="flex-item m-r-8" width={(currentElementId == "slack-type" || data.type) ? "18" : "18"} height={(currentElementId == "slack-type" || data.type) ? "18" : "18"} style={{ transition: "180ms" }} viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.73333 1H3.1C3.00717 1 2.91815 1.03687 2.85251 1.10251C2.78687 1.16815 2.75 1.25717 2.75 1.35V6.48333C2.75 6.5293 2.75905 6.57481 2.77664 6.61727C2.79423 6.65974 2.82001 6.69832 2.85251 6.73082C2.88501 6.76332 2.9236 6.7891 2.96606 6.80669C3.00852 6.82428 3.05404 6.83333 3.1 6.83333H4.73333C4.7793 6.83333 4.82481 6.82428 4.86727 6.80669C4.90974 6.7891 4.94832 6.76332 4.98082 6.73082C5.01332 6.69832 5.0391 6.65974 5.05669 6.61727C5.07428 6.57481 5.08333 6.5293 5.08333 6.48333V1.35C5.08333 1.25717 5.04646 1.16815 4.98082 1.10251C4.91518 1.03687 4.82616 1 4.73333 1V1ZM11.7333 1H10.1C10.0072 1 9.91815 1.03687 9.85251 1.10251C9.78687 1.16815 9.75 1.25717 9.75 1.35V6.48333C9.75 6.5293 9.75905 6.57481 9.77664 6.61727C9.79423 6.65974 9.82001 6.69832 9.85251 6.73082C9.88501 6.76332 9.9236 6.7891 9.96606 6.80669C10.0085 6.82428 10.054 6.83333 10.1 6.83333H11.7333C11.7793 6.83333 11.8248 6.82428 11.8673 6.80669C11.9097 6.7891 11.9483 6.76332 11.9808 6.73082C12.0133 6.69832 12.0391 6.65974 12.0567 6.61727C12.0743 6.57481 12.0833 6.5293 12.0833 6.48333V1.35C12.0833 1.25717 12.0465 1.16815 11.9808 1.10251C11.9152 1.03687 11.8262 1 11.7333 1V1Z" stroke={(currentElementId == "workout-gym-type" || data.type) ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5.08333 3.91675H9.75M1 5.31675V2.51675C1 2.42392 1.03687 2.3349 1.10251 2.26926C1.16815 2.20362 1.25717 2.16675 1.35 2.16675H2.4C2.49283 2.16675 2.58185 2.20362 2.64749 2.26926C2.71313 2.3349 2.75 2.42392 2.75 2.51675V5.31675C2.75 5.40957 2.71313 5.4986 2.64749 5.56424C2.58185 5.62987 2.49283 5.66675 2.4 5.66675H1.35C1.25717 5.66675 1.16815 5.62987 1.10251 5.56424C1.03687 5.4986 1 5.40957 1 5.31675V5.31675ZM13.8333 5.31675V2.51675C13.8333 2.42392 13.7965 2.3349 13.7308 2.26926C13.6652 2.20362 13.5762 2.16675 13.4833 2.16675H12.4333C12.3405 2.16675 12.2515 2.20362 12.1858 2.26926C12.1202 2.3349 12.0833 2.42392 12.0833 2.51675V5.31675C12.0833 5.40957 12.1202 5.4986 12.1858 5.56424C12.2515 5.62987 12.3405 5.66675 12.4333 5.66675H13.4833C13.5762 5.66675 13.6652 5.62987 13.7308 5.56424C13.7965 5.4986 13.8333 5.40957 13.8333 5.31675V5.31675Z" stroke={(currentElementId == "workout-gym-type" || data.type) ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "slack-type" || data.type) ? "10px" : "14px", color: (currentElementId == "slack-type" || data.type) ? "var(--darkBlue)" : "", transition: "180ms" }}>User Role*</p>
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" style={{ transform: slackTypeIndex == index ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                    <input id="slack-type" className={`${(currentElementId == "slack-type" || data.type) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select User Role" value={displayTypeName(data.type)} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
                    {
                      slackTypeIndex == index && (
                        <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                          {
                            slackType.map((data) => {
                              return (
                                <div onClick={()=>handleSelectSlack(data,index)} className="global-input-field-arrow-dropdown-item">
                                  <p className="flex-item">{displayTypeName(data)}</p>
                                </div>
                              )
                            })
                          }
                        </div>
                      )
                    }
                  </div>
                  <div onClick={()=>handleDeleteSlackLink(index)} className="d-flex flex-item desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                    <svg className="flex-item margin-auto" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.616 20C7.168 20 6.78667 19.8427 6.472 19.528C6.15733 19.2133 6 18.8323 6 18.385V6H5V5H9V4.23H15V5H19V6H18V18.385C18 18.845 17.846 19.2293 17.538 19.538C17.23 19.8467 16.8453 20.0007 16.384 20H7.616ZM17 6H7V18.385C7 18.5643 7.05767 18.7117 7.173 18.827C7.28833 18.9423 7.436 19 7.616 19H16.385C16.5383 19 16.6793 18.936 16.808 18.808C16.9367 18.68 17.0007 18.5387 17 18.384V6ZM9.808 17H10.808V8H9.808V17ZM13.192 17H14.192V8H13.192V17Z" fill="black"/>
                    </svg>
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className="d-flex w-full p-l-12 p-r-12">
          <div onClick={SaveSlackUrls} className={`member-button-global ${isButtonLock && "member-button-global-inactive"} btn-center flex-item d-flex w-full`} style={{padding: "0px 16px", height: "40px", borderRadius: "20px"}}>
            <p className='flex-item'>Save</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManageSlack;